import React, { useState, useEffect } from 'react';

const EditEventModal = ({ isOpen, onClose, event, onSave }) => {
  const [formData, setFormData] = useState({
    event: '',
    time: '',
    duration: 60,
    description: '',
    icon: '🎉'
  });

  useEffect(() => {
    if (event) {
      setFormData({
        event: event.event || '',
        time: event.time || '',
        duration: event.duration || 60,
        description: event.description || '',
        icon: event.icon || '🎉'
      });
    }
  }, [event]);

  const handleSave = () => {
    if (!formData.event || !formData.time) {
      alert('Please fill in event name and time');
      return;
    }
    onSave(formData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-lg z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 via-cyan-600 to-teal-600 p-6 rounded-t-3xl">
          <h2 className="text-2xl font-bold text-white">✏️ Edit Event</h2>
          <button onClick={onClose} className="absolute top-6 right-6 text-white/80 hover:text-white text-2xl">✕</button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Event Name */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Event Name</label>
            <input
              type="text"
              value={formData.event}
              onChange={(e) => setFormData({ ...formData, event: e.target.value })}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none"
              placeholder="e.g., Wedding Ceremony"
            />
          </div>

          {/* Time */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Time</label>
            <input
              type="time"
              value={(() => {
                // Convert "10:00 AM" to "10:00" for time input
                const timeParts = formData.time.match(/(\d+):(\d+)\s*(AM|PM)/i);
                if (!timeParts) return '';
                let hours = parseInt(timeParts[1]);
                const minutes = timeParts[2];
                const period = timeParts[3].toUpperCase();
                
                if (period === 'PM' && hours !== 12) hours += 12;
                if (period === 'AM' && hours === 12) hours = 0;
                
                return `${hours.toString().padStart(2, '0')}:${minutes}`;
              })()}
              onChange={(e) => {
                const time24 = e.target.value;
                if (!time24) return;
                const [hours, minutes] = time24.split(':');
                const hour = parseInt(hours);
                const period = hour >= 12 ? 'PM' : 'AM';
                const displayHour = hour > 12 ? hour - 12 : (hour === 0 ? 12 : hour);
                setFormData({ ...formData, time: `${displayHour}:${minutes} ${period}` });
              }}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none"
            />
          </div>

          {/* Duration */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Duration (minutes)</label>
            <input
              type="number"
              value={formData.duration}
              onChange={(e) => setFormData({ ...formData, duration: parseInt(e.target.value) || 0 })}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none"
              min="5"
              step="5"
            />
          </div>

          {/* Icon */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Icon</label>
            <input
              type="text"
              value={formData.icon}
              onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none text-2xl"
              placeholder="🎉"
              maxLength="2"
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Description</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none resize-none"
              rows="3"
              placeholder="Brief description..."
            />
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3 pt-4">
            <button
              onClick={handleSave}
              className="flex-1 bg-gradient-to-r from-blue-600 to-cyan-600 text-white py-3 px-6 rounded-xl font-bold hover:shadow-lg transform hover:scale-105 transition-all"
            >
              💾 Save Changes
            </button>
            <button
              onClick={onClose}
              className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-xl font-bold hover:bg-gray-50 transition-all"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEventModal;
